import React from "react";

function HomePage() {
  const birthDate = new Date(2005, 3, 21); // Month is 0-indexed, so 3 is April
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 text-center font-sans text-slate-800">
      <div>
        <h1 className="text-4xl font-extrabold text-slate-900 mb-6">Startseite</h1>
        <p className="mt-6 text-lg leading-relaxed text-slate-700">
          <b>
            Hallo und danke f&uuml;rs Vorbeischauen! Ich bin Simon Altsch&auml;ffl, {age}<span> </span>
            Jahre alt und derzeit Sch&uuml;ler der Fachrichtung Wirtschaftsinformatik an der EDV-Schule
            Plattling.
          </b>
        </p>
        <img
          src="assets/img/picture.jpg"
          alt="Mein Foto"
          className="mx-auto rounded-lg shadow-lg my-8 max-w-full h-auto border border-slate-200"
        />
        <p className="text-lg leading-relaxed text-slate-600 mb-4">
          <em>Willkommen auf meiner Website!</em> Hier stelle ich mich detailliert vor,
          pr&auml;sentiere meine Projekte und teile meine Erfahrungen in der
          Informatik.
        </p>

        <p className="text-lg leading-relaxed text-slate-600">
          Entdecken Sie meine bereits abgeschlossenen sowie die aktuell noch in Entwicklung befindlichen Projekte. Außerdem k&ouml;nnen Sie hier mehr &uuml;ber mich und meine Ziele erfahren und gerne direkt mit mir Kontakt aufnehmen.
        </p>
      </div>
    </section>
  );
}

export default HomePage;